export enum FieldsName {
  title = 'title',
  artistName = 'artistName',
  releaseDate = 'releaseDate',
}

export type FieldsType = {
  [FieldsName.title]: string;
  [FieldsName.artistName]: string;
  /** `YYYY-MM-DD`, the format both the date input and the server read. */
  [FieldsName.releaseDate]: string;
};
